
import swal from 'sweetalert';
import ApiCaller from '../../../api/ApiCaller';
import { toast } from 'react-toastify';

export const isDeleteRecord = (url, refreshTable, data = []) => {
    swal({
        title: "Are you sure?",
        buttons: {
            cancel: true,
            confirm: true,
        },
        text: "Are you sure that you want to delete this record?",
        icon: "warning",
        dangerMode: true,
    }).then((result) => {
        if (result) {
            if (data.length > 0) {
                ApiCaller.callPostApi(url, data, {}, (response) => {
                    toast.success("record Delete successfully");
                    refreshTable()
                    // if (response.success) {
                    //     // toast.success(response.message);
                    //     // refreshTable()
                    // } else {
                    //     // toast.error(response.message);
                    // }
                }, (error) => {
                    // toast.error(error.response.data.message);
                });
            } else {
                ApiCaller.callDeleteApi(url, {}, (response) => {
                    // console.log("response ============ ", response)
                    if (response?.success) {
                        toast.success(response?.message || "Deleted Successfully");
                        if (refreshTable) {
                            refreshTable()
                        }
                    } else {
                        toast.error(response?.message || "Something went wrong");
                    }
                }, (error) => {
                    // toast.error(error.response.data.message);
                });
            }
        }
    });
}

export const isActiveRecord = () => {
    swal({
        title: "Are you sure?",
        buttons: {
            cancel: true,
            confirm: true,
        },
        text: "Are you sure that you want to Active this record?",
        icon: "warning",
        dangerMode: true,
    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result) {
            swal({
                title: "Activated",
                // text: "You clicked the button!",
                icon: "success",
            })
        }
    });
}

export const isInActiveRecord = () => {
    swal({
        title: "Are you sure?",
        buttons: {
            cancel: true,
            confirm: true,
        },
        text: "Are you sure that you want to Un-Active this record?",
        icon: "warning",
        dangerMode: true,
    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result) {
            swal({
                title: "UnActivate",
                // text: "You clicked the button!",
                icon: "success",
            })
        }
    });
}
